import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/blogOverrides.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Temporary client-side hide of the HomePage story button
try {
  const hideStoryCta = () => {
    if (window.location && (window.location.pathname === '/' || window.location.pathname === '/home')) {
      const btns = document.querySelectorAll('button');
      for (const b of Array.from(btns)) {
        const t = (b.textContent || '').trim();
        if (t === 'Příběh vzniku právního bota') {
          (b as HTMLElement).style.display = 'none';
          return true;
        }
      }
    }
    return false;
  };

  // Run immediately and also observe for React renders
  if (!hideStoryCta()) {
    const mo = new MutationObserver(() => {
      if (hideStoryCta()) mo.disconnect();
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    // Fallback timeout disconnect
    setTimeout(() => mo.disconnect(), 5000);
  }
} catch {}

// Add small red TOP badge next to "Analýza smluv" in navigation
try {
  const injectTopBadge = () => {
    let injected = false;

    const makeBadge = () => {
      const b = document.createElement('span');
      b.textContent = 'TOP';
      Object.assign(b.style, {
        marginLeft: '6px',
        padding: '0 6px',
        height: '18px',
        lineHeight: '18px',
        borderRadius: '10px',
        backgroundColor: '#e72f0d',
        color: '#fff',
        fontSize: '10px',
        fontWeight: '700',
        letterSpacing: '0.4px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
      } as CSSStyleDeclaration);
      b.setAttribute('data-top-badge', '1');
      return b;
    };

    // Prefer header navigation container
    const headerNav = document.getElementById('primary-navigation');
    const scopeSelectors = headerNav ? ['#primary-navigation [role="link"]'] : ['[role="link"]'];

    for (const sel of scopeSelectors) {
      const linkNodes = Array.from(document.querySelectorAll(sel)).filter((n) => /Analýza\s+smluv/i.test((n.textContent || '').trim()));
      for (const link of linkNodes) {
        const style = window.getComputedStyle(link as HTMLElement);
        if ((link as HTMLElement).offsetParent === null || style.display === 'none' || style.visibility === 'hidden') continue;
        const labels = Array.from(link.querySelectorAll('p, span, div')).filter((n) => /Analýza\s+smluv/i.test((n.textContent || '').trim()));
        const labelEl = labels[labels.length - 1] || link;
        if (labelEl && !labelEl.querySelector('[data-top-badge="1"]')) {
          labelEl.appendChild(makeBadge());
          injected = true;
        }
      }
      if (injected) break;
    }

    return injected;
  };

  if (!injectTopBadge()) {
    const mo2 = new MutationObserver(() => {
      if (injectTopBadge()) mo2.disconnect();
    });
    mo2.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => mo2.disconnect(), 6000);
  }
} catch {}
